export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

export interface SubSortColumn {
  key: string;
  columnId: string;
}

const isValidDate = (value: string): boolean => {
  const date = new Date(value);
  return !isNaN(date.getTime());
};

export const sort = <T>(array: T[], key: string, direction: SortDirection, subColumn?: SubSortColumn): T[] =>
  array.slice().sort((a: any, b: any) => {
    const descending = direction === SortDirection.DESC;

    let keyA = a[key];
    let keyB = b[key];

    if (subColumn && Array.isArray(keyA) && Array.isArray(keyB)) {
      // Assuming you want to sort by the first matching sub-column value
      keyA = keyA.find((sub: any) => sub[subColumn.key] === subColumn.columnId)?.value;
      keyB = keyB.find((sub: any) => sub[subColumn.key] === subColumn.columnId)?.value;
    }

    if ((keyA == null && keyB == null) || keyA === keyB) return 0;
    if (keyA == null) return descending ? 1 : -1;
    if (keyB == null) return descending ? -1 : 1;

    if (typeof keyA === 'string' && typeof keyB === 'string') {
      const isKeyADate = isValidDate(keyA);
      const isKeyBDate = isValidDate(keyB);

      if (isKeyADate && isKeyBDate) {
        const dateA = new Date(keyA).getTime();
        const dateB = new Date(keyB).getTime();
        return descending ? dateB - dateA : dateA - dateB;
      }

      if (isKeyADate) return descending ? 1 : -1;
      if (isKeyBDate) return descending ? -1 : 1;

      // Otherwise, compare as strings
      return descending ? keyB.localeCompare(keyA) : keyA.localeCompare(keyB);
    }

    if (typeof keyA === 'number' && typeof keyB === 'number') {
      return descending ? keyB - keyA : keyA - keyB;
    }

    if (keyA instanceof Date && keyB instanceof Date) {
      return descending ? keyB.getTime() - keyA.getTime() : keyA.getTime() - keyB.getTime();
    }

    return 0;
  });
